import { render, staticRenderFns } from "./Layer.vue?vue&type=template&id=cfd5abdc&scoped=true"
import script from "./Layer.vue?vue&type=script&lang=js"
export * from "./Layer.vue?vue&type=script&lang=js"
import style0 from "./Layer.vue?vue&type=style&index=0&id=cfd5abdc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfd5abdc",
  null
  
)

export default component.exports